export default __webpack_public_path__ + "static/media/photo--sm--99.29544763.jpg";